var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertRedHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.6 132",
    style: {
      enableBackground: "new 0 0 8.6 132"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE3823;}\n\t.st1{fill:#9CB6B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.3,
    className: "st0",
    width: 8.6,
    height: 131.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,132H0.2v-12h8.5V132z M8.7,108H0.2V96h8.5V108z M8.7,84H0.2V72h8.5V84z M8.7,59.9H0.2v-12h8.5V59.9z  M8.7,35.9H0.2v-12h8.5V35.9z M8.7,11.9H0.2v-12h8.5V11.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertRedHalf);
export default __webpack_public_path__ + "static/media/vertRedHalf.49fbaf4c9a71e9f664ad1a9902501097.svg";
export { ForwardRef as ReactComponent };